const pendingLayoutReads = new Set<() => void>()
const pendingLayoutWrites = new Set<() => void>()
let layoutFrameId: number | null = null

function flushLayoutQueue() {
  layoutFrameId = null
  const layoutReads = [...pendingLayoutReads]
  pendingLayoutReads.clear()
  for(const layoutRead of layoutReads) {
    layoutRead()
  }
  const layoutWrites = [...pendingLayoutWrites]
  pendingLayoutWrites.clear()
  for(const layoutWrite of layoutWrites) {
    layoutWrite()
  }
}

function requestLayoutFrame() {
  layoutFrameId ??= requestAnimationFrame(flushLayoutQueue)
}

export function scheduleLayoutRead(layoutRead: () => void): void {
  pendingLayoutReads.add(layoutRead)
  requestLayoutFrame()
}

export function scheduleLayoutWrite(layoutWrite: () => void): void {
  pendingLayoutWrites.add(layoutWrite)
  requestLayoutFrame()
}

export function cancelLayoutRead(layoutRead: () => void): void {
  pendingLayoutReads.delete(layoutRead)
}

export function cancelLayoutWrite(layoutWrite: () => void): void {
  pendingLayoutWrites.delete(layoutWrite)
}
